﻿/* globals HeaderDTO */
require('../Common/Layout/layout');
require("../Global/facebook");
require("../Global/google-login");
require('./modules/footer');
require('../Global/credential-management');
var Functions = require('./modules/functions');
var jquery = require("jquery");
var HabEvents = require('../Global/habitaclia-events');
var AccountUser = require('./modules/account-user');
var Header = require('./modules/header');

require('polyfills');

(function () {

    'use strict';


    var LayoutDesktop = function () {
        AccountUser.RegisterEvents();
        this.headerBusquedas = jquery('#js-header-busquedas');
        this.headerNotificaciones = jquery('#js-header-notificaciones');
        this.headerNav = jquery('#js-head-nav');
        this.headerFav = jquery('#js-head-fav');
        this.previewContainer = jquery('.preview_busquedas');
        this.header = new Header(HeaderDTO);

        __registerEvents.call(this);
    };

    var __registerEvents = function(){
        var self = this;

        self.header.registerEvents();

        jquery(document).ready(function(){
            jquery('body').click(function(e){
                Functions.bindBodyCloseEvent(this, e);
            });

            jquery('#js-head-publish').click(function (e) {
                e.preventDefault();
                var url = jquery(this).attr('href');
                jquery.publish(HabEvents.EventsEnum.PublishAd, url);
            });
        });

        jquery.subscribe(HabEvents.EventsEnum.CloseMenusHeader, function () {
            __closeDropdown.call(self);
            self.previewContainer.addClass('hide-none');
        });

        jquery('.selected-language').click(function(){
            var $target =  jquery('#idSelectIdioma');
            if($target.hasClass('hide')){
                $target.removeClass('hide');
                $target.addClass('show');
            }
            else{
                $target.removeClass('show');
                $target.addClass('hide');
            }
        });


        this.headerNotificaciones.bind('click mouseover', function () {
            __closeDropdown.call(self);
            jquery('#js-preview-busquedas').addClass('hide-none');
        });
        this.headerBusquedas.bind('click mouseover', function () {
            __closeDropdown.call(self);
            jquery('#js-preview-notificaciones').addClass('hide-none');
        });
        this.headerFav.bind('click mouseover', function () {
            __closeDropdown.call(self);
            self.previewContainer.addClass('hide-none');
        });
        this.headerNav.bind('click mouseover', function () {
            self.previewContainer.addClass('hide-none');
        });
    };

    var __closeDropdown = function () {
        jquery('.dropdown').removeClass('active');
        jquery('.dropdown-container').removeClass('show').addClass('hide');
    };

    LayoutDesktop.prototype = {
        constructor: LayoutDesktop
    };

    if (typeof module !== 'undefined' && module.exports) {
        /*jshint undef: false*/
        module.exports = new LayoutDesktop();
    }
    else {
        window.LayoutDesktop = LayoutDesktop;
    }

})();

